module.exports = __webpack_public_path__ + "img/LG_usa-silhouette.d3788399.png";